module.exports = require("./src/jquery.waitforimages.js");


/*****************
 ** WEBPACK FOOTER
 ** waitForImages (bower component)
 ** module id = 7
 ** module chunks = 0
 **/